export default __webpack_public_path__ + "static/media/Roboto-Light.8be2d148.ttf";